import { translate } from '@/ui/i18n';

import EventsIconSvg from '../assets/events_icon.svg';
import GroupPeopleSvg from '../assets/group_people.svg';
import styles from '../styles/VenueDateManagement.module.css';
import { displayDecimal } from '../utils/display-scores.utils';
import { ParityBar } from './ParityBar';

type Props = {
  data: {
    participants: number;
    dates: number;
    parity: {
      men: number;
      women: number;
      other: number;
    };
    totalStructureEmissions: number;
    totalDatesEmissions: number;
  };
};

export function VenueDateManagement(props: Props) {
  const { data } = props;
  return (
    <>
      <div className="columnar-table">
        <h2>{translate('PdfExports.date-management')}</h2>
        <div className={styles.gridContainer}>
          <div>
            <div className={`${styles.headerCell} ${styles.headerCellLeft}`}>
              <div className={styles.headerText}>
                {translate('PdfExports.dates-and-public')}
              </div>
            </div>
            <div
              className={`${styles.contentCell} ${styles.contentCellLeft}`}
              style={{ padding: '8px 15px' }}
            >
              <div>
                <img
                  src={GroupPeopleSvg}
                  width="19"
                  height="19"
                  style={{ position: 'relative', top: 2, marginRight: 8 }}
                  alt="Calendar icon"
                />
                <span className={styles.largeNumber}>{data.participants}</span>
                <span className={styles.normalText}>
                  {' '}
                  {translate('PdfExports.participants', {
                    count: data.participants,
                  })}
                </span>
              </div>
              <div>
                <img
                  src={EventsIconSvg}
                  width="19"
                  height="19"
                  style={{ position: 'relative', top: 2, marginRight: 8 }}
                  alt="Calendar icon"
                />
                <span className={styles.largeNumber}>{data.dates}</span>
                <span className={styles.normalText}>
                  {' '}
                  {translate('PdfExports.events', { count: data.dates })}
                </span>
              </div>
            </div>
          </div>

          <div>
            <div className={styles.headerCell}>
              <div className={styles.headerText}>
                {translate('PdfExports.team-parity')}
              </div>
            </div>
            <div className={styles.contentCell}>
              <div className={styles.parityContainer}>
                <ParityBar data={data} />
              </div>
            </div>
          </div>

          <div>
            <div className={`${styles.headerCell} ${styles.headerCellRight}`}>
              <div className={styles.headerText}>
                {translate('PdfExports.emissions')}
              </div>
            </div>
            <div className={`${styles.contentCell} ${styles.contentCellRight}`}>
              <div className={styles.emissionsRow}>
                <div className={styles.emissionsBox}>
                  <span className={styles.emissionsLabel}>CO2</span>
                  <div className={styles.emissionsValue}>
                    {displayDecimal(data.totalDatesEmissions)}
                  </div>
                </div>
                <span className={styles.emissionsDescription}>
                  {translate('PdfExports.date-emissions')}
                </span>
              </div>
              <div className={styles.emissionsRow}>
                <div className={styles.emissionsBox}>
                  <span className={styles.emissionsLabel}>CO2</span>
                  <div className={styles.emissionsValue}>
                    {displayDecimal(data.totalStructureEmissions)}
                  </div>
                </div>
                <span className={styles.emissionsDescription}>
                  {translate('PdfExports.structure-emissions')}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="navigation-controls">
        <a href="#page2" className="tag-pill">
          {translate('PdfExports.go-to-score-details')}
        </a>
      </div>
    </>
  );
}
